import type { TransitionStageRequest } from "@/marketing/models/campaignInfluencer";

// Adds quiet: true only when quiet mode is on. When off, the key must be absent —
// facade rejects unknown fields (forbidNonWhitelisted) on deployments without quiet support.
export function applyQuiet(
  request: TransitionStageRequest,
  quiet: boolean,
): TransitionStageRequest {
  const { quiet: _existing, ...rest } = request;
  return quiet ? { ...rest, quiet: true } : rest;
}
